import { ITooltipProperties } from '@vfde-brix/ws10/tooltip';
import { Tooltip } from '../../interfaces/additionalPageOptions';

export const getTooltipProps = (id: string, config?: Tooltip): ITooltipProperties | undefined => {
    if (!config) {
        return;
    }

    const tooltipProps: ITooltipProperties = {
        stdTooltipId: id,
        stdHeadline: config.headline || '',
        txtContent: config.text || '',
        business: {},
    };

    return tooltipProps;
};
